import { createFileRoute } from '@tanstack/react-router';

import { BreaksGalleryPage } from '../../features/manager-breaks-demo/components/BreaksGalleryPage';

export const Route = createFileRoute('/_onboarding/breaks')({
  component: BreaksRoute,
});

function BreaksRoute() {
  return <BreaksGalleryPage />;
}
